class SubCollection extends HTMLElement {
  constructor() {
    super()

    this.dataGroup = document.querySelector('.sub-collection').getAttribute('data-group')
    this.facetTrash = document.querySelector('.facet-trash a')
    this.container = document.querySelector('.sub-collections-container')

    this.initialiseSubCollection()
  }

  initialiseSubCollection() {
    if (this.container === null) {
      this.style.display = 'none'
    } else {
      this.container.appendChild(this)
      this.container.querySelectorAll('.sub-collection__item').forEach(item => {
        item.style.display = 'block'
      })
      this.addEventListener('click', this.handleClick)
    }
  }

  handleClick(event) {
    const target = event.target
    const dataValue = this.dataset.value
    this.handleFacet(dataValue, target) 
  }

  handleFacet(dataValue, target) { 
    const activeFacets = document.querySelectorAll('.active-facets a')
    if (dataValue !== 'Accessories' || this.dataGroup == 'false') {
      let clickFacet = true
      activeFacets.forEach(facet => {
        if (facet.textContent.includes(dataValue)) {
          // target.classList.remove('sub-collection__item--selected')
          facet.click()
          clickFacet = false
        }
      })

      if (clickFacet) {
        const element = document.querySelector(`[value="${dataValue}"]`)
        element.click()
        // target.classList.add('sub-collection__item--selected')
      }

    } else {
      // handle accessories group...
      let group = []

      const element = document.querySelector(`[value="${dataValue}"]`)
      group.push(element)

      const headwear = document.querySelector(`[value="Headwear"]`)
      if (headwear !== null) {
        group.push(headwear)
      }
      const socks = document.querySelector(`[value="Socks"]`)
      if (socks !== null) {
        group.push(socks)
      }
      const thrubark = document.querySelector(`[value="Thrubark"]`)
      if (thrubark !== null) {
        group.push(thrubark)
      }
      const gloves = document.querySelector(`[value="Gloves"]`)
      if (gloves !== null) {
        group.push(gloves)
      }
      // loop group and add... 
      group.forEach(item => {
        item.click()
      })
    }
  }
}

customElements.define('sub-collection', SubCollection)
